import { render, staticRenderFns } from "./notice_process.vue?vue&type=template&id=4f17546e&scoped=true&"
import script from "./notice_process.vue?vue&type=script&lang=js&"
export * from "./notice_process.vue?vue&type=script&lang=js&"
import style0 from "./notice_process.vue?vue&type=style&index=0&id=4f17546e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f17546e",
  null
  
)

export default component.exports